<template>
    <div>
        <div class="guest-logo">
            <img
                src="/images/logo.png"
                alt="goTenna Pro Management Portal"
            />
        </div>

        <div class="module form-module">
            <header class="module__header">
                <router-link
                    to="/login"
                    class="back-btn router-link-active"
                    data-test-id="forgot-password-back-button"
                >
                    <span class="icon-chevron-left"></span>
                </router-link>

                <h1 class="has-back-btn">Forgot Password</h1>
            </header>

            <section class="module__body">
                <form
                    data-test-id="forgot-password-form"
                    @submit.prevent="login"
                >
                    <div class="form-group">
                        <p data-test-id="forgot-password-instructions">
                            You will receive an email that will allow you to create a new password for your account(s).
                        </p>
                    </div>

                    <div class="form-group">
                        <label for="email">Email</label>
                        <input
                            id="email"
                            ref="email"
                            v-model="email"
                            data-test-id="forgot-password-email-field"
                            type="email"
                            required
                            maxlength="255"
                        />
                    </div>

                    <form-errors :response="errorResponse"></form-errors>

                    <div class="form-group">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            :class="{ active: submitted }"
                            data-test-id="forgot-password-submit-button"
                        >
                            <div>Submit</div>
                        </button>
                    </div>
                </form>
            </section>
        </div>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'

export default {
    components: {
        FormErrors,
    },

    mixins: [canToast],

    data() {
        return {
            email: null,
            errorResponse: null,
            submitted: false,
        }
    },

    mounted() {
        this.$nextTick(() => this.$refs.email.focus())
    },

    methods: {
        login() {
            this.submitted = true

            this.$http
                .post('auth/send-password-reset-link', {
                    email: this.email,
                })
                .then(() => {
                    this.toast(
                        `If an account exists for address ${this.email}, an
                            email has been sent with additional instructions.`,
                        'success',
                        8000
                    )
                    this.$router.push({ name: 'login' })
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },
    },
}
</script>
